enum TechnologyChangesType {
    Added = "Added",
    Removed = "Removed",
    Renew = "Renew",
    RenewalComingUp = "RenewalComingUp",
}

export default TechnologyChangesType;
